import { useCallback, useState } from 'react';
import { API } from '../api';
import { download } from '../utils';
import { useToast } from '../ui/Toast';

// Downloads a host's CycloneDX SBOM as JSON. `busy` holds the hostname being downloaded.
export default function useCycloneDx() {
  const toast = useToast();
  const [busy, setBusy] = useState(null);

  const downloadFor = useCallback(async (hostname) => {
    setBusy(hostname);
    try {
      const data = await API.GET_HOST_CYCLONEDX(hostname);
      download(data, 'application/json', `${hostname}_cyclonedx.json`);
    } catch (error) {
      toast.error(`Could not download the CycloneDX file for ${hostname}: ${error.message}`);
    } finally {
      setBusy(null);
    }
  }, [toast]);

  return { busy, download: downloadFor };
}
